var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon (heroicons-mini) https://heroicons.com/"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38409 10.9675C3.14522 11.1972 3.13778 11.577 3.36745 11.8159C3.59713 12.0547 3.97695 12.0622 4.21582 11.8325L7.81582 8.4325C7.93347 8.31938 7.99995 8.16321 7.99995 8C7.99995 7.83679 7.93347 7.68062 7.81582 7.5675L4.21582 4.1675C3.97695 3.93782 3.59713 3.94527 3.36745 4.18414C3.13778 4.423 3.14522 4.80282 3.38409 5.0325L6.53429 8L3.38409 10.9675Z",
    fill: "#2A2B42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18409 10.9675C7.94522 11.1972 7.93778 11.577 8.16745 11.8159C8.39713 12.0547 8.77695 12.0622 9.01582 11.8325L12.6158 8.4325C12.7335 8.31938 12.8 8.16321 12.8 8C12.8 7.83679 12.7335 7.68062 12.6158 7.5675L9.01582 4.1675C8.77695 3.93782 8.39713 3.94527 8.16745 4.18414C7.93778 4.423 7.94522 4.80282 8.18409 5.0325L11.3343 8L8.18409 10.9675Z",
    fill: "#2A2B42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/DoubleArrow.128890edb47b35ff09d05142a349eb98.svg";
export { ForwardRef as ReactComponent };